// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"bb6dd162","368":"7b066fa1","427":"7cbc1692","496":"53d4beba","540":"899a73c5","583":"0085214a","623":"f7e8857e","894":"093c7ad2"}[chunkId] + ".chunk.js";
};